<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Jack Compton’s Luck</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="aboutAuthorPage" id="ata01"><a id="page05"><h2 class="aboutAuthorHead"><span class="bold"><span>PAULA MARSHALL,</span></span></h2><p class="aboutAuthorText"><span>married with three children, has had a varied life. She began her career in a large library and ended it as a senior academic in charge of history in a polytechnic. She has traveled widely, has been a swimming coach and has appeared on television in <em class="italic"><span>University Challenge</span></em> and <em class="italic"><span>Mastermind.</span></em> She has always wanted to write, and likes her novels to be full of adventure and humor.</span></p></a></div>
<a id="page05">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// jackcomptonsluck_ata01.vue?2382625b